import React, { useState } from "react";
import "./style.scss";
import { Dialog, Message } from "@jdcfe/legao";
import CreateAppInput from "./../../components/CreateAppInput";
import { queryCreateApp } from "utils/api";
import { observer } from "mobx-react-lite";
import useStore from "stores";

const CreateAppStepOne = observer(() => {
  const [createLoading, setCreateLoading] = useState(false);
  const { overviewStore } = useStore();
  const sureClick = (createapp) => {
    const appName = document.querySelector(".appName .lg-input-o").value;
    const authCallbackUrl = document.querySelector(
      ".authCallbackUrl .lg-input-o"
    ).value;
    const developerPhone = document.querySelector(".developerPhone .lg-input-o")
      .value;
    const developerEmail = document.querySelector(".developerEmail .lg-input-o")
      .value;
    if (createLoading) {
      Message.showMsg({
        showIcon: true,
        type: "warn",
        description: "请稍等再试",
        autohide: true,
        closable: false,
        duration: 3000,
      });
      return;
    }
    setCreateLoading(true);
    queryCreateApp({
      appName,
      authCallbackUrl,
      developerPhone,
      developerEmail,
    }).then((res) => {
      if (document.querySelector(".input_item.error"))
        document.querySelector(".input_item.error").classList.remove("error");
      if (!res.data.success) {
        if (res.data.resultCode === "30000005") {
          document
            .querySelector(".appName")
            .parentNode.setAttribute("class", "input_item error");
          document.querySelector(".appName").nextSibling.innerHTML =
            res.data.resultMessage;
        } else if (res.data.resultCode === "30000006") {
          document
            .querySelector(".authCallbackUrl")
            .parentNode.setAttribute("class", "input_item error");
          document.querySelector(".authCallbackUrl").nextSibling.innerHTML =
            res.data.resultMessage;
        } else if (res.data.resultCode === "30000007") {
          document
            .querySelector(".developerEmail")
            .parentNode.setAttribute("class", "input_item error");
          document.querySelector(".developerEmail").nextSibling.innerHTML =
            res.data.resultMessage;
        } else if (res.data.resultCode === "30000008") {
          document
            .querySelector(".developerPhone")
            .parentNode.setAttribute("class", "input_item error");
            document.querySelector(".developerPhone").nextSibling.innerHTML = res.data.resultMessage;
        }else{
          Message.showMsg({
            showIcon: true,
            type: "wrong",
            description:res.data.resultMessage,
            autohide: true,
            closable: false,
            duration: 1000,
          });
        }
      } else {
        if (document.querySelector(".input_item.error"))
          document.querySelector(".input_item.error").classList.remove("error");
        // 创建成功后将新app加到frameStore里
        // frameStore.appApp(res.result);

        Message.showMsg({
          showIcon: true,
          type: "success",
          description: "创建成功",
          autohide: true,
          closable: false,
          duration: 1000,
        });
        setTimeout(() => {
          overviewStore.getApplist().then(() => {
            createapp.close();
          });
        }, 1000);
        setTimeout(() => {
          location.reload();
        }, 2000);
      }
      setCreateLoading(false);
    });
  };

  const handleCreate = () => {
    const createapp = Dialog.confirm({
      title: "创建应用",
      children: <CreateAppInput></CreateAppInput>,
      wrapStyle: {
        zIndex: 99,
      },
      actions: [
        {
          text: "提交",
          onClick: () => {
            sureClick(createapp);
          },
          className: "sure",
          styleType: "primary",
          autoClose: false,
        },
        {
          text: "取消",
          onClick: () => createapp.close(),
          className: "cancel",
          styleType: "",
        },
      ],
      className: "create_dialog",
    });
  };

  return (
    <div className="step_one">
      <div className="one_contain">
        <i className="one_img"></i>
        <div className="one_tips">暂无应用，请先创建一个吧</div>
        <div className="one_button">
          <button className="one_create" onClick={handleCreate}>
            创建应用
          </button>
        </div>
      </div>
    </div>
  );
});
export default CreateAppStepOne;
